import { Button } from 'shared/ui/Button';
import { InfoBox } from 'shared/ui/InfoBox';
import { useModalsActions } from 'shared/ui/SideModal';
import { showSuccessToast } from 'shared/lib/notifications';
import { AddCardFormModal } from 'features/add-card';

interface AddCardBlockProps {
  className?: string;
  refetchUserData: () => void;
}

export function AddCardBlock({ refetchUserData, className }: AddCardBlockProps) {
  const { open } = useModalsActions();

  return (
    <InfoBox
      className={className}
      title="🎉 Congratulations!"
      text="You successfully created your campaign. To activate your campaign,
        please add your credit card."
      button={
        <Button
          className="w-[195px]"
          iconLeftName="add_circle_outline"
          onClick={() => {
            open(
              <AddCardFormModal
                onAdded={() => {
                  refetchUserData();
                  showSuccessToast(
                    'Your credit card was successfully added. You can manage your credit cards from the Billing tab.'
                  );
                }}
              />
            );
          }}
        >
          Add credit card
        </Button>
      }
    />
  );
}
